<template>
  <section class="asset-navigation">
    <div><nav v-if="links.length" aria-label="مسیر دارایی"><router-link v-for="link in links" :key="link.label" :to="link.to">{{ link.label }}</router-link></nav><h2>{{ title }}</h2><p>{{ description }}</p></div>
    <div class="asset-navigation-actions"><slot /></div>
  </section>
</template>
<script>
export default { props: { title: String, description: String, links: { type: Array, default: () => [] } } };
</script>
<style>
.asset-navigation { display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:20px; margin-bottom:24px; padding:24px; background:#fff; border:1px solid #e0e6ef; border-radius:14px }
.asset-navigation h2 { font-size:20px; margin:8px 0; color:#25344e; line-height:1.7 }
.asset-navigation p { font-size:13px; color:#697890; margin:0; line-height:1.9 }
.asset-navigation nav { display:flex; gap:12px; flex-wrap:wrap; font-size:13px }
.asset-navigation nav a { color:#3453a1; text-decoration:underline; text-underline-offset:4px }
.asset-navigation-actions { display:flex; flex-wrap:wrap; gap:8px }
.asset-navigation-actions a { display:inline-flex; align-items:center; justify-content:center; min-height:44px; padding:10px 16px; border:1px solid #ced7e5; border-radius:9px; color:#3453a1; background:#fff; text-decoration:none; font-size:13px }
.asset-navigation-actions a.primary { background:#3453a1; color:#fff; border-color:#3453a1 }
.asset-navigation-actions a:hover,.asset-navigation-actions a:focus-visible { color:#25324b; background:#edf2ff }
.asset-navigation-actions a.primary:hover,.asset-navigation-actions a.primary:focus-visible { color:#fff; background:#243e80 }
.asset-name-link { color:#284e9c; font-weight:600; text-decoration:underline; text-underline-offset:4px }
</style>
